<template>
    <div>
        <rica-vue-stepper
            v-if="!stepperIsDisabled"
            class="rica-vue-stepper"
            :steps="routes"
            :max-index="stepperMaxIndex"
            :step-navigation-is-disabled="stepperIsDisabled"
            primary-color="#00559a"
            pending-text-color="#006bc2">
        </rica-vue-stepper>
        <transition appear name="slide-fade" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import RicaVueStepper from '@ricadesign/vue-wizard';
import routes from '../../js/router/wizard';

export default {
    props:{
        registration: {
            type: Object,
            required: false
        },
        redsysParams: {
            type: Object,
            required: false
        },
        payment_error: {
            type: Boolean,
            default: false
        },
    },
    components: {
        RicaVueStepper,
    },
    data() {
        return {
            routes: routes[0].children.slice(0, -3)
        }
    },
    computed: {
        stepperMaxIndex() {
            return this.routes.findIndex(route => route.name === this.$route.name) - 1;
        },
        stepperIsDisabled() {
            return this.$route.name === 'confirmacion-preinscripcion';
        }
    },
    created() {
        this.$store.commit("setState", { prop: "locale", value: window.appLocale });
        this.$store.commit("setState", { prop: "trans", value: window.trans });
        this.$store.dispatch("loadCourses");
    },
}
</script>

<style lang="scss">
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
